import Image from 'next/image';
import { useQueryState } from 'nuqs';
import React, { type PropsWithChildren } from 'react';

import Link from '@/components/CustomLink';
import { type Layout } from '@/typings/NextJS';

import s from './CreatorEditLayout.module.scss';

type Props = {
  creator?: {
    id: string;
  } | null;
};

const CreatorEditLayout: Layout<PropsWithChildren<Props>> = ({ children }) => {
  const [queryTab] = useQueryState('tab');

  return (
    <div className={s.container}>
      <div>{children}</div>
      {queryTab !== 'Chat' && (
        <Link newTab to='https://www.glade.ai' className={s.footer}>
          Powered by <Image src='/full-glade-logo.png' width={72} height={16} alt='Glade AI' />
        </Link>
      )}
    </div>
  );
};

export default CreatorEditLayout;
